import React from "react";
import { Wifi, WifiOff, RefreshCw } from "lucide-react";
import { useOfflineSync } from "@/context/OfflineSyncContext";
import { useI18n } from "@/i18n/I18nContext";

// variant="bar": en la barra superior, solo cuando hay algo que decir (sin
// conexión o datos por enviar); conectado y al día no ocupa sitio.
const NetworkStatusWidget = ({ variant = "chip" }) => {
  const { isOffline, queue, manualSync } = useOfflineSync();
  const { t } = useI18n();

  if (variant === "bar") {
    if (!isOffline && queue.length === 0) return null;
    return (
      <button type="button" onClick={manualSync} data-testid="navbar-network"
        className={`inline-flex items-center gap-1 h-8 px-2 rounded-xl text-xs font-bold ${
          isOffline ? "bg-rose-500/90 text-white animate-pulse" : "bg-amber-400 text-amber-950"}`}
        title={isOffline ? t("network.offline_tooltip", "Sin conexión. Toca para reintentar.")
          : t("network.sync_tooltip", "Datos pendientes de sincronizar. Toca para forzar.")}
        aria-label={isOffline ? t("network.offline", "Desconectado") : `${queue.length} ${t("network.pending", "Pendientes")}`}>
        {isOffline ? <WifiOff size={14} aria-hidden="true" /> : <><RefreshCw size={14} aria-hidden="true" /> {queue.length}</>}
      </button>
    );
  }

  // Si no estamos offline y no hay nada en la cola, el widget puede ser muy sutil o casi invisible
  // Pero como el usuario quería un botón, lo mostramos siempre.
  return (
    <button
      onClick={manualSync}
      className={`flex items-center gap-1.5 px-2.5 sm:px-3 h-8 rounded-full shadow-sm border transition-all text-[0.6875rem] font-bold uppercase tracking-wider ${
        isOffline
          ? "bg-rose-50 border-rose-200 text-rose-600 hover:bg-rose-100 animate-pulse"
          : queue.length > 0
          ? "bg-amber-50 border-amber-200 text-amber-600 hover:bg-amber-100"
          : "bg-white/80 backdrop-blur-md border-slate-200 text-slate-500 hover:bg-slate-50"
      }`}
      title={
        isOffline
          ? t("network.offline_tooltip", "Sin conexión. Toca para reintentar.")
          : queue.length > 0
          ? t("network.sync_tooltip", "Datos pendientes de sincronizar. Toca para forzar.")
          : t("network.online_tooltip", "Conectado. Toca para verificar.")
      }
    >
      {isOffline ? (
        <>
          <WifiOff size={14} />
          <span>{t("network.offline", "Desconectado")}</span>
        </>
      ) : queue.length > 0 ? (
        <>
          <RefreshCw size={14} className="animate-spin-slow" />
          <span>{queue.length} {t("network.pending", "Pendientes")}</span>
        </>
      ) : (
        <>
          <Wifi size={14} className="text-emerald-500" />
          {/* En el móvil, conectado = solo el icono (el aviso importa sin conexión) */}
          <span className="sr-only sm:not-sr-only">{t("network.online", "Online")}</span>
        </>
      )}
    </button>
  );
};

export default NetworkStatusWidget;
